import { AppContextProvider } from '@startupquickstart/frontend';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppContextProvider defaultTheme="light">
      <App />
    </AppContextProvider>
  </StrictMode>,
);
